import { useCallback } from "react";
import { useAccount, useWriteContract } from "wagmi";
import { waitForTransactionReceipt } from "@wagmi/core";
import { parseUnits } from "viem";
import ABIUSDC from "../../utils/usdcAbi.json";
import Environment from "../../utils/Environment";
import { wagmiConfig } from "../../wagmiConfig";

const useApproveTplUsdc = () => {
  const { address: account, isConnected } = useAccount();
  const { writeContractAsync } = useWriteContract();

  const approveTplUsdc = useCallback(
    async (amount) => {
      if (!isConnected || !account) {
        throw new Error("WALLET_NOT_CONNECTED");
      }

      try {
        const approveAmount = parseUnits(amount.toString(), 6);

        const hash = await writeContractAsync({
          address: Environment.usdc,
          abi: ABIUSDC,
          functionName: "approve",
          args: [Environment.presaleContract, approveAmount],
        });

        console.log("Approval tx hash:", hash);

        const receipt = await waitForTransactionReceipt(wagmiConfig, { hash });

        console.log("Approval confirmed:", receipt);

        return { transactionHash: hash, receipt };
      } catch (error) {
        console.error("Approval failed:", error);
        throw error;
      }
    },
    [account, isConnected, writeContractAsync]
  );

  return { approveTplUsdc };
};

export default useApproveTplUsdc;
